import { ChatAppResponse } from "../../api";

type HtmlParsedAnswer = {
    answerHtml: string;
};

export function parseAnswerToHtml(answer: ChatAppResponse, isStreaming: boolean): HtmlParsedAnswer {
    const content = answer.message.content;
    let answerHtml = "";

    if (typeof content === "string") {
        // If it's a string simply trim it.
        answerHtml = content.trim();
    } else if (typeof content === "object" && content !== null) {
        // If it's an object, assume it has "subject" and "body" properties.
        // You can adjust the HTML formatting as required.
        const subjectHtml = content.subject ? `<strong>${content.subject}</strong><br/>` : "";
        const bodyHtml = content.body ? content.body.toString() : "";
        answerHtml = `${subjectHtml}${bodyHtml}`.trim();
    }

    return { answerHtml };
}
